import './dashboards-view/dashboards-view.components';
import './dashboards-view/dashboards-view.scss';

import './dashboard-view/dashboard-view.component';
import './dashboard-view/dashboard-view.scss';

import './dashboards-list/dashboards-list.component';
import './dashboards-list/dashboards-list.scss';

import './dashboard-form/dashboard-form.component';
import './dashboard-form/dashboard-form.scss';

import './widget-form/widget-form.component';
import './widget-form/widget-form.scss';

import './dashboards-table/dashboards-table.component';
import './dashboards-table/dashboards-table.scss';

import './dashboards-table-row/dashboards-table-row.component';
import './dashboards-table-row/dashboards-table-row.scss';

import './widget-container/widget-container.component';
import './widget-container/widget-container.scss';

import './agents-table-view/agents-table-view.component';
import './agents-table-view/agents-table-view.scss';
